import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { openAiChat } from '@euler/app/flows/ai-suite/openAiChat';
import { aiSuiteToolForSession } from '@euler/app/flows/ai-suite/theme';
import { ReviewAction } from '@euler/app/flows/apdm/imports/ReviewControls';
import { parseAiBundleHandoff } from '@euler/model/ai-home';
import { Text, View } from 'react-native';
import { useTheme } from 'styled-components';

export function AiBundleHandoffWidget({
  data,
  streaming = false,
}: {
  data: unknown;
  streaming?: boolean;
}) {
  const value = parseAiBundleHandoff(data);
  const navigation = useAppNavigation();
  const theme = useTheme();
  if (!value)
    return (
      <Text style={{ color: theme.label.color }}>
        对话入口格式不完整，请重新描述您的目标。
      </Text>
    );
  return (
    <View style={{ paddingVertical: 12 }}>
      <Text style={{ color: theme.label.color, marginBottom: 8 }}>
        {value.prompt}
      </Text>
      <ReviewAction
        title="为这个目标新建对话"
        disabled={streaming}
        onPress={() =>
          openAiChat(navigation, {
            kind: 'new',
            tool: aiSuiteToolForSession(value.bundleId),
            bundleId: value.bundleId,
            message: { text: value.prompt, attachments: [] },
          })
        }
      />
    </View>
  );
}
